import gql from 'graphql-tag';
import error from './partials/error';
import measureForList from './partials/measureForList';
import node from './partials/node';

// eslint-disable-next-line import/prefer-default-export
const defaultFields = `
  ${node}
  ${measureForList}
  ${error}
`;

export default (fields = defaultFields, queryName = 'getMeasuresById') => gql`query ${queryName}(
  $filter: MeasureFilter,
  $first: Int,
  $offset: Int = 0,
  $sortBy: String,
  $sortDesc: Boolean = false
) {
  measurements(
    filter: $filter,
    paging: {
      first: $first,
      offset: $offset,
      sortBy: $sortBy,
      sortDesc: $sortDesc
    }
  ) {
    __typename

    totalCount

    pageInfo {
      # endCursor
      hasNextPage
      hasPreviousPage
      # startCursor
    }

    nodes {
      ${fields}
    }
  }
}`;
